import React, { useEffect } from "react";
import API from "@/common/API";
import moment from "moment";
import { useTranslation } from "react-i18next";

const VehicleVisit = props => {
    const [records, setRecords] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const { t } = useTranslation();
    const fetchRecords = async () => {
        try {
            setLoading(true);
            const response = await API.getAction('placeVisit/VehicleVisits?placeId=' + props.id);
            if (response.data.status === "ok") {
                setRecords(response.data.response);
            }
        } catch (error) {
            console.error('Error fetching vehicle visits:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRecords();
    }, [props.id]);

    if (records.length === 0 && !loading) {
        return null;
    }
    return (
        <div className="card shadow-sm my-4">
            <div className="card-header">
                <h5 className="card-title">{t("Vehicle Visits")}</h5>
            </div>
            <div className="card-body">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">{t("Date")}</th>
                                <th scope="col">{t("Name")}</th>
                                <th scope="col">{t("Distance (mts)")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {records.map(record => (
                                <tr key={record.id}>
                                    <td>{moment(record.visitDate).fromNow()}</td>
                                    <td>{record.vehicleName}</td>
                                    <td>{record.distance.toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );

}

export default VehicleVisit;